import { useQuery } from 'react-query';

import { getClusterType as queryFn } from 'api/endPoints/getClusterType';

export const useQueryGetNlpThresholds = (params) => {
    return useQuery({
        queryKey: ['getNlpThresholds', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
    });
};
